import { api, RouterOutput } from "../../../services/rpc/RpcProvider";

export type Resource = RouterOutput["system"]["resources"]["list"][0];

export const Resources = {
  identifier: (resource: Resource) => `resource:${resource.type}:${resource.id}`
};

export const useResources = (resourceType: string, options?: any) => {
  const { data: resources, isLoading } = api.system.resources.list.useQuery(
    { resourceType },
    options
  );

  return { resources, loading: isLoading };
};

export const useResourceTypes = () => {
  const { data: resourceTypes, isLoading } = api.system.resources.types.useQuery({});

  return { resourceTypes, loading: isLoading };
};
